import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import FinancialSummaryList from "../../components/affiliates/FinancialSummaryList";

const statusFilterOptions = [
  { label: "Ne pritje", id: 0 },
  { label: "Aprovuar", id: 1 },
  { label: "Refuzuar", id: 2 },
  { label: "Pezulluar", id: 3 }
];

const AffiliateFinancialSummary: React.FC = () => {
  return (
    <>
      <HeaderPage
        hasFilter
        filterName="Statusi"
        filterSelctor="status"
        options={statusFilterOptions}
      />
      <FinancialSummaryList />
    </>
  );
};

export default AffiliateFinancialSummary;
